module.exports = __webpack_public_path__ + "img/tcrb.4fe4558d.svg";